// Get the price from the dummy mural product

// Declare globally
let dummyMuralPrice = null;
let dummyMuralPriceGBP = null;

// Fetch the product

fetch(window.Shopify.routes.root + 'products/dummy-mural.js')
  .then(response => {
    if (!response.ok) throw new Error('Failed to fetch dummy mural');
    return response.json();
  })
  .then(product => {
    dummyMuralPrice = product.price;
    console.log('Price fetched:', dummyMuralPrice);
    // Optionally trigger an update right away
    updatePriceUI(250,250);
  })
  .catch(error => {
    console.error('Error fetching product:', error);
  });

fetch(window.Shopify.routes.root + 'products/dummy-mural.js', {credentials:"omit"})
  .then(response => {
    if (!response.ok) throw new Error('Failed to fetch dummy mural');
    return response.json();
  })
  .then(product => {
    dummyMuralPriceGBP = product.price;
    console.log('GBP Price fetched:', dummyMuralPriceGBP);
    // Optionally trigger an update right away
    updatePriceUI(250,250);
  })
  .catch(error => {
    console.error('Error fetching product:', error);
  });

let product_image = null;
let product_image_id = null;
console.log("window.location.href + '.js'", window.location.href + '.js')

fetch(window.location.origin + window.location.pathname + '.json', {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
})
  .then(response => {
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return response.json();
  })
  .then(data => {
    console.log('Raw product data:', data);
    product_image = data.product.images[0].src;
    product_image_id = data.product.images[0].id;
    console.log('Product image fetched:', product_image);
  })
  .catch(error => {
    console.error('Error fetching product JSON:', error);
  });



// Get the mural image URL from the data attribute
const muralImageURL = document.querySelector("#wall-mural-preview").getAttribute("data-img");

// Initialize the mural dimensions (used only for aspect ratio)
let muralObj = signal({ width: 250, height: 250 }, 'mural');
let currentUnit = 'cm';
const CM_TO_INCH = 0.393701;
const INCH_TO_CM = 1 / CM_TO_INCH;

// Initialize UI
const widthInput = document.querySelector("#canvas-width");
const heightInput = document.querySelector("#canvas-height");
const unitSelector = document.querySelector("#unit-selector");
unitSelector.value = currentUnit;
//Initialize canvas elements

const canvas = document.querySelector("#wall-mural-preview");
const ctx = canvas.getContext("2d", { alpha: false });
const gridCanvas = document.querySelector("#grid-overlay");
const gridCtx = gridCanvas.getContext('2d');
// Reactive grid state variable
let settings = signal({ gridEnabled: false }, 'settings');

// Ruler canvases and measurement value spans
const widthRulerCanvas = document.querySelector('.width-measurement-ruler');
const heightRulerCanvas = document.querySelector('.height-measurement-ruler');
const widthRulerCtx = widthRulerCanvas.getContext('2d');
const heightRulerCtx = heightRulerCanvas.getContext('2d');
const widthValueSpan = document.querySelector('.width-measurement-value');
const heightValueSpan = document.querySelector('.height-measurement-value');

updateInputValues();

unitSelector.addEventListener("change", handleUnitChange);
widthInput.addEventListener("change", handleSizeChange);
heightInput.addEventListener("change", handleSizeChange);


// Mural size signal
document.addEventListener("signal:mural", function(e) {
    if (e.detail.key === "width" || e.detail.key === "height") {
        resizeCanvas(); // call new dynamic resize
        updatePriceUI(muralObj.width, muralObj.height);
        console.log(muralObj)
    }
});

// Settings Signal
document.addEventListener('signal:settings', (e) => {
  if (e.detail.key === 'gridEnabled') {
    drawStaticGrid(e.detail.value);
  }
});

function handleUnitChange() {
    const newUnit = unitSelector.value;
    if (newUnit === currentUnit) return;
    
    currentUnit = newUnit;
    updateInputValues();
    
    widthInput.step = currentUnit === 'cm' ? '1' : '0.1';
    heightInput.step = currentUnit === 'cm' ? '1' : '0.1';

    drawRulers();
}

function handleSizeChange(e) {
    const rawValue = parseFloat(e.target.value);
    const isWidth = e.target.id === "canvas-width";
    // Convert input value to centimeters (internal units)
    const cmValue = currentUnit === 'cm' ? rawValue : rawValue / CM_TO_INCH;
    
    if (isWidth) {
        muralObj.width = Math.round(cmValue);
    } else {
        muralObj.height = Math.round(cmValue);
    }
    
    // When dimensions change, resize the canvas
    resizeCanvas();
}



// -------------------------------
// Code for quantity selector buttons in the style of the theme to measurements
// -------------------------------


if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init(); // DOM already ready
}

function init() {

  const controlGroups = document.querySelectorAll('.control-group');

  controlGroups.forEach(group => {
    const input = group.querySelector('.measurement-input');
    const decreaseButton = group.querySelector('.measurement-decrease');
    const increaseButton = group.querySelector('.measurement-increase');

    let intervalId;

    function adjustValue(direction) {
      const currentValue = parseFloat(input.value) || 0;
      const step = parseFloat(input.step) || 1;
      const min = parseFloat(input.min) || 0;
      const newValue = direction === 'up' ? currentValue + step : currentValue - step;

      if (direction === 'down' && newValue < min) return;

      input.value = roundToStep(newValue, step);
      input.dispatchEvent(new Event('change'));
    }

    function startAdjusting(direction) {
      adjustValue(direction);
      intervalId = setInterval(() => adjustValue(direction), 100); // adjust speed here (ms)
    }

    function stopAdjusting() {
      clearInterval(intervalId);
    }

    // Decrease button events
    decreaseButton.addEventListener('mousedown', () => startAdjusting('down'));
    decreaseButton.addEventListener('mouseup', stopAdjusting);
    decreaseButton.addEventListener('mouseleave', stopAdjusting);
    decreaseButton.addEventListener('touchstart', () => startAdjusting('down'));
    decreaseButton.addEventListener('touchend', stopAdjusting);

    // Increase button events
    increaseButton.addEventListener('mousedown', () => startAdjusting('up'));
    increaseButton.addEventListener('mouseup', stopAdjusting);
    increaseButton.addEventListener('mouseleave', stopAdjusting);
    increaseButton.addEventListener('touchstart', () => startAdjusting('up'));
    increaseButton.addEventListener('touchend', stopAdjusting);
  });

  // Helper function to fix floating-point rounding errors
  function roundToStep(value, step) {
    const decimals = (step.toString().split('.')[1] || '').length;
    return parseFloat(value.toFixed(decimals));
  }
}

// // -------------------------------
// // Signal function using proxies
// // -------------------------------

function signal(data = {}, name = '') {    
    function handler(data, name) {
        return {
            get(obj, key) {
                if (key === '_isProxy') return true;
                let nested = ['[object Object]', 'object Array'];
                let type = Object.prototype.toString.call(obj[key]);
                if (nested.includes(type) && !obj[key]._isProxy) {
                    obj[key] = new Proxy(obj[key], handler(name, data));
                }
                return obj[key];
            },
            set(obj, key, value) {
                if (obj[key] === value) return true;
                obj[key] = value;
                emit(name, { key, value, action: 'set' });
                return true; 
            },
            deleteProperty(obj, key) {
                delete obj[key];
                emit(name, { key, value: obj[key], action: 'delete' });
                return true;
            }
        }

    }
    return new Proxy(data, handler(data, name));
}

// -------------------------
// Emit custom event
// -------------------------
function emit(name, detail = {}) {
    let event = new CustomEvent(`signal:${name}`, {
        bubbles: true,
        detail: detail
    });
    return document.dispatchEvent(event);
}

// -------------------------
// Price calculation
// -------------------------


function updatePriceUI(width, height) {
    const square_meters = (width / 100) * (height / 100);
    if (dummyMuralPrice !== null && dummyMuralPriceGBP !== null) { 

      const total_price_el = document.querySelector(".total-price");
      const price_per_meter_el = document.querySelector(".price-per-meter");
      
      const moneyFormat = theme.settings.money_format;
      var currency_rate = Shopify.currency.rate;
      var minimum_price = (155 * currency_rate);
      var minimum_price_gbp = 155;
      
      const strippedFormat = moneyFormat.replace(/<[^>]*>/g, "");
      const match = strippedFormat.match(/([^<{]*?){{[^}]+}}([^}>]*?)/);
      const currencySymbolBefore = match?.[1].trim() || "";
      const currencySymbolAfter = match?.[2].trim() || "";
  
      if (total_price_el) {
        let total_price = (dummyMuralPrice / 100) * square_meters;
        let total_price_gbp = (dummyMuralPriceGBP / 100) * square_meters;

        let final_price = total_price > minimum_price ? total_price : minimum_price;
        let final_price_gbp = total_price_gbp > minimum_price_gbp ? total_price_gbp.toFixed(2) : minimum_price_gbp.toFixed(2);
        
        total_price_el.textContent = `${currencySymbolBefore}${final_price.toFixed(2)}${currencySymbolAfter}`;
        total_price_el.setAttribute("data-gbp-price", final_price_gbp);
      }

      if (price_per_meter_el) {
        let price_per_meter = (dummyMuralPrice / 100).toFixed(2);
        price_per_meter_el.textContent = `${currencySymbolBefore}${price_per_meter}${currencySymbolAfter} per m2`;
      }
    } else {
      console.warn('Price not available yet.');
    }
}

// -------------------------
// Get product image from canvas
// -------------------------

function captureVisibleCanvas(maxWidth = 800, quality = 0.8) {
  const sourceCanvas = document.querySelector("#wall-mural-preview");

  const originalWidth = sourceCanvas.width;
  const originalHeight = sourceCanvas.height;

  // Resize only if needed
  const scale = originalWidth > maxWidth ? maxWidth / originalWidth : 1;

  const targetWidth = originalWidth * scale;
  const targetHeight = originalHeight * scale;

  const resizedCanvas = document.createElement("canvas");
  resizedCanvas.width = targetWidth;
  resizedCanvas.height = targetHeight;

  const ctx = resizedCanvas.getContext("2d");
  ctx.drawImage(sourceCanvas, 0, 0, targetWidth, targetHeight);

  // Convert to base64 JPEG with reduced quality (smaller size)
  const base64Image = resizedCanvas.toDataURL("image/jpeg", quality);

  return base64Image;
}


// -------------------------
// Add to cart
// -------------------------

// Sends measurements and product information to app to create new product
// Adds to cart after response from app 


document.querySelector('#mural-add-to-cart').addEventListener('click', async (e) => { 
  document.querySelector('#mural-add-to-cart').classList.add("is-loading")
  
  const shop_domain = Shopify.shop;
  const mural_price = document.querySelector(".total-price").getAttribute('data-gbp-price');
  let product_title = document.querySelector(".product__content  .product__title").textContent;
  product_title = `${product_title} (${muralObj.width}x${muralObj.height})`;


  const postData = {
    shopify_domain: shop_domain,
    product_image: product_image,
    product_price: mural_price,
    product_title: product_title
  };

  try {
    const resp = await fetch("https://woodchip.herokuapp.com/api/products.json", {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(postData)
    });

    const data_repository = await resp.json();
    console.log('data_repository: ', data_repository);

    const order_note = document.querySelector('#order-note').value;

    // 👇 Get canvas image
    let preview_image = captureVisibleCanvas(); // returns a <canvas> element
    // console.log( "preview_image",preview_image)
    const base64Data = preview_image;

    // 👇 Upload to Cloudinary
    const cloudForm = new FormData();
    cloudForm.append('file', base64Data);
    cloudForm.append('upload_preset', 'w_m_murals');
    cloudForm.append('folder', 'shopify_uploads');

    const cloudRes = await fetch('https://api.cloudinary.com/v1_1/dfroyqdhb/image/upload', {
      method: 'POST',
      body: cloudForm
    });

    const cloudData = await cloudRes.json();
    const imageUrl = cloudData.secure_url;

    if (!imageUrl) {
      alert("Image upload failed");
      return; 
    }

    // ✅ Add to cart after upload
    const add_api_cart_data = {
      items: [
        {
          quantity: 1,
          id: data_repository.variant_id,
          price: data_repository.variant_price,
          properties: {
            'Size': `${muralObj.width}x${muralObj.height}`,
            'Price': `£${document.querySelector(".total-price").getAttribute('data-gbp-price')}`, 
            'Comment': order_note,
            'Preview Image URL': imageUrl,
            '_Original Product': window.location.pathname 
          }
        }
      ]
    };

    console.log("add_api_cart_data", add_api_cart_data);
    add_cart_dynamically(add_api_cart_data);

  } catch (err) {
    console.error(err);
    alert("Something went wrong.");
  }
});

// Leave these functions unchanged
function add_cart_dynamically(add_api_cart_data) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(add_api_cart_data)
  })
  .then(resp => resp.json())
  .then(data => {
    update_cart_count();
  })
  .catch(err => { alert(err); });
}

function update_cart_count() {
  fetch('/cart.js')
  .then(resp => resp.json())
  .then(cart => {
    // console.log(cart);
    document.querySelector('#mural-add-to-cart').classList.remove("is-loading")
    location.reload(); 
  });
}

// -------------------------
// Canvas Elements
// -------------------------

const PANEL_WIDTH_CM = 52;
const REAL_HEIGHT_CM = 200;
const REAL_DPI = 10;

const image = new Image();
image.crossOrigin = "anonymous";
image.src = muralImageURL;

let isDragging = false;
let startX = 0;
let offsetX = 0;

function addDraggableIndicators() {
  // Create draggable hint element
  const hintElement = document.createElement('div');
  hintElement.className = 'draggable-hint';
  hintElement.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M14 5l-5 5 5 5"/>
      <path d="M10 5l5 5-5 5"/>
    </svg>
    <span>Drag to adjust image</span>
  `;
  
  // Add hint to canvas container
  const canvasContainer = document.querySelector('.canvas-container');
  canvasContainer.appendChild(hintElement);
  
  // Show hint on first load
  setTimeout(() => {
    hintElement.classList.add('show', 'hint-pulse');
    
    // Hide hint after 4 seconds
    setTimeout(() => {
      hintElement.classList.remove('show', 'hint-pulse');
    }, 4000);
  }, 1000);
  
  // Show hint on hover/touch
  canvas.addEventListener('mouseenter', () => {
    if (!isDragging) {
      hintElement.classList.add('show');
    }
  });
  
  canvas.addEventListener('mouseleave', () => {
    if (!isDragging) {
      hintElement.classList.remove('show');
    }
  });
  
  // For touch devices
  canvas.addEventListener('touchstart', () => {
    // Show hint briefly on first touch
    if (!canvas.hasAttribute('data-touched')) {
      hintElement.classList.add('show');
      canvas.setAttribute('data-touched', 'true');
      
      setTimeout(() => {
        hintElement.classList.remove('show');
      }, 2000);
    }
  }, { once: true });
  
  // Hide hint during dragging
  const originalMouseDown = canvas.onmousedown;
  canvas.addEventListener('mousedown', () => {
    hintElement.classList.remove('show');
  });
  
  // Add visual feedback during drag
  canvas.addEventListener('mousedown', () => {
    canvas.style.cursor = 'grabbing';
  });
  
  canvas.addEventListener('mouseup', () => {
    canvas.style.cursor = 'grab';
  });
}

image.onload = function() {
    grayscaleImage = createGrayscaleImage(image);
    resizeCanvas(); // call dynamic resize on image load
    addDraggableIndicators(); // add draggable indicators
};

// Mouse events for dragging on the main canvas
canvas.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.clientX - offsetX;
});
canvas.addEventListener('mousemove', (e) => {
    if (isDragging) {
        offsetX = e.clientX - startX;
        offsetX = Math.max(-image.width, Math.min(offsetX, image.width));
        drawHorizontallyTiledImage(isGrayscale ? grayscaleImage : image);
    }
});
canvas.addEventListener('mouseup', () => { isDragging = false; });
canvas.addEventListener('mouseleave', () => { isDragging = false; });

canvas.addEventListener('touchstart', (e) => {
  isDragging = true;
  startX = e.touches[0].clientX - offsetX;
  e.preventDefault(); // Prevent scrolling while dragging
});
canvas.addEventListener('touchmove', (e) => {
  if (isDragging) {
      offsetX = e.touches[0].clientX - startX;
      offsetX = Math.max(-image.width, Math.min(offsetX, image.width));
      drawHorizontallyTiledImage(isGrayscale ? grayscaleImage : image);
      e.preventDefault(); // Prevent scrolling while dragging
  }
});
canvas.addEventListener('touchend', () => { 
  isDragging = false; 
});
canvas.addEventListener('touchcancel', () => { 
  isDragging = false; 
});

/* 
  Updated resizeCanvas() function:
  - Uses the parent element's dimensions ('.canvas-container') 
  - Computes the new width and height while preserving the aspect ratio from muralObj 
  - Sets the main canvas and grid overlay to these dimensions
  - Sets the ruler canvases so that the width ruler is always 30px tall and matches the canvas width,
    and the height ruler is always 30px wide and matches the canvas height.
*/


function updateMeasurementLabels() {
  // decide whether to show cm or in
  const displayWidth  = currentUnit === 'cm'
    ? muralObj.width
    : muralObj.width * CM_TO_INCH;
  const displayHeight = currentUnit === 'cm'
    ? muralObj.height
    : muralObj.height * CM_TO_INCH;

  // how many decimals? 0 for cm, 1 for in
  const digits = currentUnit === 'cm' ? 0 : 1;

  widthValueSpan.textContent  = `${displayWidth.toFixed(digits)} ${currentUnit}`;
  
  const widthRulerWidth = document.querySelector(".width-measurement-ruler").width;
  widthValueSpan.style.left = `${( widthRulerWidth / 2)}px`;

  heightValueSpan.textContent = `${displayHeight.toFixed(digits)} ${currentUnit}`;
  
  const heightRulerHeight = document.querySelector(".height-measurement-ruler").height;
  heightValueSpan.style.top = `${(heightRulerHeight / 2)}px`;

}



function updateInputValues() {
  const width = currentUnit === 'cm' ? muralObj.width : muralObj.width * CM_TO_INCH;
  const height = currentUnit === 'cm' ? muralObj.height : muralObj.height * CM_TO_INCH;
  widthInput.value = width.toFixed(currentUnit === 'cm' ? 0 : 1);
  heightInput.value = height.toFixed(currentUnit === 'cm' ? 0 : 1);

  updateMeasurementLabels();
}


const H_PAD = 30;   // horizontal padding on left and right of width ruler
const V_PAD = 30;   // vertical padding on top and bottom of height ruler

function resizeCanvas() {
  // 1) Get the parent element that constrains the mural preview.
  const parentContainer = document.querySelector('.mural-app-preview-container');
  const parent = document.querySelector('.mural-app-preview');
  
  const parentWidth = Math.floor(parentContainer.clientWidth);
  const parentHeight = Math.floor(parentContainer.clientHeight);

  // 2) Read desired mural size (in cm) from your reactive object.
  let desiredWidth  = muralObj.width;   // centimeters
  let desiredHeight = muralObj.height;  // centimeters

  // 3) Compute newCanvasWidth and newCanvasHeight (in px) to fit the container,
  //    preserving the aspect ratio of desiredWidth:desiredHeight.
  let newCanvasWidth;
  let newCanvasHeight;
  
  const aspectRatio = desiredWidth / desiredHeight;
  if (parentWidth / parentHeight > aspectRatio) {
      // newCanvasHeight = parentHeight;
      newCanvasHeight = parentHeight;

      newCanvasWidth  = parentHeight * aspectRatio;
  } else {
      newCanvasWidth  = parentWidth;
      newCanvasHeight = parentWidth / aspectRatio;
  }

  newCanvasWidth  = Math.floor(newCanvasWidth);
  newCanvasHeight = Math.floor(newCanvasHeight);

  // 4) Resize the main mural canvas and its grid overlay (backing store).

  canvas.width      = newCanvasWidth;
  canvas.height     = newCanvasHeight;
  gridCanvas.width  = newCanvasWidth;
  gridCanvas.height = newCanvasHeight;

  let hint = document.querySelector(".draggable-hint");
  if (hint) {
    hint.style.top = `${newCanvasHeight / 2 }px`;
  }


  // 5) Resize the width-ruler canvas:
  //    - Backing-store width = newCanvasWidth + 2*H_PAD (so you have 30px on each side).
  //    - CSS display width = same expanded width, so the padding is visible.
  widthRulerCanvas.width       = newCanvasWidth + 2 * H_PAD;
  widthRulerCanvas.style.width = `${newCanvasWidth + 2 * H_PAD}px`;
  //    - Backing-store height and CSS display height remain 30px.
  widthRulerCanvas.height      = 30;
  widthRulerCanvas.style.height= `30px`;

  // 6) Resize the height-ruler canvas:
  //    - Backing-store height = newCanvasHeight + 2*V_PAD.
  //    - CSS display height = same expanded height.
  heightRulerCanvas.height       = newCanvasHeight + 2 * V_PAD;
  heightRulerCanvas.style.height = `${newCanvasHeight + 2 * V_PAD}px`;
  //    - Backing-store width and CSS display width remain 30px.
  heightRulerCanvas.width        = 30;
  heightRulerCanvas.style.width  = `30px`;

  // 7) Allow the extra padded area to overflow the wrapper so the 30px margins show.
  widthRulerCanvas.parentElement.style.overflow  = 'visible';
  heightRulerCanvas.parentElement.style.overflow = 'visible';

  // 8) If the mural image is loaded, redraw it and the grid overlay.
  if (image.complete) {
      drawHorizontallyTiledImage(isGrayscale ? grayscaleImage : image);
      drawStaticGrid(settings.gridEnabled);
  }

  // 9) Update the floating measurement labels and redraw the rulers.
  updateMeasurementLabels();
  drawRulers();
  
}

  

// Listen for window resize events to trigger a canvas resize
window.addEventListener('resize', resizeCanvas);

// -------------------------
// Ruler Drawing Functions
// -------------------------
let globalPixelPerUnit = 1;
function drawRulers() {
    drawWidthRuler();
    drawHeightRuler();
    console.log(globalPixelPerUnit);
}

function drawWidthRuler() {
  // 1) Acquire the 2D context and canvas dimensions (including padding).
  const ctx = widthRulerCtx;
  const W   = widthRulerCanvas.width;   // backing-store width = display width + 2*H_PAD
  const H   = widthRulerCanvas.height;  // 30px

  // 2) Clear the entire canvas.
  ctx.clearRect(0, 0, W, H);

  // 3) Set stroke, fill, font, and text alignment.
  ctx.strokeStyle = '#666';
  ctx.fillStyle   = '#333';
  ctx.font        = '12px Arial';
  ctx.textAlign   = 'center';

  // 4) Compute the inner drawable width (excluding the left/right padding).
  const innerWidth = W - 2 * H_PAD;     // equals the mural’s display width in pixels

  // 5) Branch on metric vs imperial.
  if (currentUnit === 'cm') {
      // 5a) Metric: 1 px/cm on innerWidth.
      const totalCm   = muralObj.width;  // e.g. 400
      const pxPerCm   = innerWidth / totalCm;
      const minorStep = 10;               // every 1 cm
      const majorStep = 100;              // label every 10 cm

      for (let cm = 0; cm <= totalCm; cm += minorStep) {
          // 5b) X coordinate offset by left padding.
          const x       = H_PAD + cm * pxPerCm;
          const isMajor = (cm % majorStep === 0);

          // 5c) Draw tick.
          ctx.beginPath();
          ctx.moveTo(x, isMajor ? 15 : 25);
          ctx.lineTo(x, H);
          ctx.stroke();

          // 5d) Draw label for major ticks.
          if (isMajor) {
              ctx.fillText(`${cm} cm`, x, 10);
          }
      }
  } else {
      // 5e) Imperial: compute total inches (float) and exact px/inch.
      const totalInches    = muralObj.width * CM_TO_INCH;
      const pxPerInchExact = innerWidth / totalInches;
      const minorStep      = 1;           // every 1"
      const majorStep      = 12;          // label every 12"

      for (let inch = 0; inch <= totalInches; inch += minorStep) {
          // 5f) X coordinate offset by left padding.
          const x       = H_PAD + inch * pxPerInchExact;
          const isMajor = (Math.round(inch) % majorStep === 0);

          // 5g) Draw tick.
          ctx.beginPath();
          ctx.moveTo(x, isMajor ? 15 : 25);
          ctx.lineTo(x, H);
          ctx.stroke();

          // 5h) Draw label for major ticks (rounded inch).
          if (isMajor) {
              ctx.fillText(`${Math.round(inch)}"`, x, 10);
          }
      }
  }
}


function drawHeightRuler() {
  // 1) Acquire the 2D context and canvas dimensions (including padding).
  const ctx = heightRulerCtx;
  const W   = heightRulerCanvas.width;   // 30px
  const H   = heightRulerCanvas.height;  // display height + 2*V_PAD

  // 2) Clear the entire canvas.
  ctx.clearRect(0, 0, W, H);

  // 3) Set stroke, fill, font, text alignment, and baseline.
  ctx.strokeStyle  = '#666';
  ctx.fillStyle    = '#333';
  ctx.font         = '12px Arial';
  ctx.textAlign    = 'center';
  ctx.textBaseline = 'middle';

  // 4) Compute the inner drawable height (excluding top/bottom padding).
  const innerHeight = H - 2 * V_PAD;     // equals the mural’s display height in pixels

  // 5) Branch on metric vs imperial.
  if (currentUnit === 'cm') {
      // 5a) Metric: 1 px/cm on innerHeight.
      const totalCm   = muralObj.height;
      const pxPerCm   = innerHeight / totalCm;
      const minorStep = 10;               // every 1 cm
      const majorStep = 100;              // label every 10 cm

      for (let cm = 0; cm <= totalCm; cm += minorStep) {
          // 5b) Y coordinate measured from bottom, offset by bottom padding.
          const y       = H - V_PAD - cm * pxPerCm;
          const isMajor = (cm % majorStep === 0);

          // 5c) Draw tick.
          ctx.beginPath();
          ctx.moveTo(W, y);
          ctx.lineTo(isMajor ? 15 : 25, y);
          ctx.stroke();

          // 5d) Draw rotated label for major ticks.
          if (isMajor) {
              ctx.save();
              ctx.translate(W - 10, y);
              ctx.rotate(-Math.PI / 2);
              ctx.fillText(`${cm} cm`, 0, 0);
              ctx.restore();
          }
      }
  } else {
      // 5e) Imperial: compute total inches (float) and exact px/inch.
      const totalInches    = muralObj.height * CM_TO_INCH;
      const pxPerInchExact = innerHeight / totalInches;
      const minorStep      = 1;           // every 1"
      const majorStep      = 12;          // label every 12"

      for (let inch = 0; inch <= totalInches; inch += minorStep) {
          // 5f) Y coordinate measured from bottom, offset by bottom padding.
          const y       = H - V_PAD - inch * pxPerInchExact;
          const isMajor = (Math.round(inch) % majorStep === 0);

          // 5g) Draw tick.
          ctx.beginPath();
          ctx.moveTo(W, y);
          ctx.lineTo(isMajor ? 15 : 25, y);
          ctx.stroke();

          // 5h) Draw rotated label for major ticks (rounded inch).
          if (isMajor) {
              ctx.save();
              ctx.translate(W - 10, y);
              ctx.rotate(-Math.PI / 2);
              ctx.fillText(`${Math.round(inch)}"`, 0, 0);
              ctx.restore();
          }
      }
  }
}



// -------------------------
// Measuring Tool Function
// -------------------------

        // const crosshairCanvas = document.getElementById('wall-mural-preview');
        // const crosshairCtx = crosshairCanvas.getContext('2d');
        // const tooltip = document.getElementById("crosshair-tooltip");
        
        // // Set canvas dimensions
        // crosshairCanvas.width = muralObj.width;
        // crosshairCanvas.height = muralObj.height;

        // function drawLines(mouseX, mouseY) {
        //     // Clear canvas
        //     crosshairCtx.clearRect(0, 0, crosshairCanvas.width, crosshairCanvas.height);
            
        //     // Set line style
        //     crosshairCtx.strokeStyle = '#ff0000';
        //     crosshairCtx.lineWidth = 1;
            
        //     // Draw vertical line (top to cursor)
        //     crosshairCtx.beginPath();
        //     crosshairCtx.moveTo(mouseX, 0);
        //     crosshairCtx.lineTo(mouseX, mouseY);
        //     crosshairCtx.stroke();
            
        //     // Draw horizontal line (left to cursor)
        //     crosshairCtx.beginPath();
        //     crosshairCtx.moveTo(0, mouseY);
        //     crosshairCtx.lineTo(mouseX, mouseY);
        //     crosshairCtx.stroke();
        // }

        // crosshairCanvas.addEventListener('mousemove', (e) => {
        //     // Get canvas position and mouse coordinates
        //     const rect = crosshairCanvas.getBoundingClientRect();
        //     const mouseX = e.clientX - rect.left;
        //     const mouseY = e.clientY - rect.top;
            
        //     // Update lines
        //     drawLines(mouseX, mouseY);
            
        //     // Update tooltip
        //     tooltip.style.display = 'block';
        //     tooltip.textContent = `(${Math.round(mouseX)}, ${Math.round(mouseY)})`;
        //     tooltip.style.left = `${e.clientX + 10}px`;
        //     tooltip.style.top = `${e.clientY + 10}px`;
        // });

        // crosshairCanvas.addEventListener('mouseleave', () => {
        //     // Clear canvas and hide tooltip when mouse leaves
        //     crosshairCtx.clearRect(0, 0, crosshairCanvas.width, crosshairCanvas.height);
        //     tooltip.style.display = 'none';
        // });

// -------------------------
// Main Canvas Image Drawing
// -------------------------
function drawHorizontallyTiledImage(sourceImage) { 
    const aspectRatio = sourceImage.width / sourceImage.height;
    const scaledImageWidth = aspectRatio * canvas.height;
    const scaledImageHeight = canvas.height;

    ctx.save();
    if (isFlipped) {
        ctx.scale(-1, 1);
        ctx.translate(-canvas.width, 0);
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const visibleLeft = -scaledImageWidth;
    const visibleRight = canvas.width + scaledImageWidth;
    const startX = Math.floor((offsetX + visibleLeft) / scaledImageWidth);
    const endX = Math.ceil((offsetX + visibleRight) / scaledImageWidth);

    for (let x = startX; x <= endX; x++) {
        const drawX = x * scaledImageWidth - offsetX;
        ctx.drawImage(sourceImage, drawX, 0, scaledImageWidth, scaledImageHeight);
    }
    
    ctx.restore();
}

// -------------------------
// Grid, Flip, and Grayscale Functions
// -------------------------
document.addEventListener("click", function(e) {
    if (e.target.id === "canvasGrid") {
      settings.gridEnabled = !settings.gridEnabled;
      drawStaticGrid(settings.gridEnabled);
    }
    if (e.target.id === "flipImage") {
        flipImage();
    } 
    if (e.target.id === "toggleGrayscale") {
        toggleGrayscale();
    }
    if (e.target.id === "toggleRulers") {
      toggleRulers();
    }
    
});

  function drawStaticGrid(gridEnabled) {
    if (gridEnabled) {
      gridCtx.clearRect(0, 0, gridCanvas.width, gridCanvas.height);
      gridCtx.strokeStyle = 'rgba(102, 255, 0, 1)';
      gridCtx.lineWidth = 1;

      // Calculate px per cm based on current canvas width and mural width in cm
      const pxPerCm = canvas.width / muralObj.width;
      const gridSpacingPx = 52 * pxPerCm;

      for (let x = 0; x <= gridCanvas.width; x += gridSpacingPx) {
        gridCtx.beginPath();
        gridCtx.moveTo(x, 0);
        gridCtx.lineTo(x, gridCanvas.height);
        gridCtx.stroke();
      }
    } else {
      gridCtx.clearRect(0, 0, gridCanvas.width, gridCanvas.height);
    }
  }


let isFlipped = false;
function flipImage() {
    isFlipped = !isFlipped;
    drawHorizontallyTiledImage(isGrayscale ? grayscaleImage : image);
}

function toggleRulers() {
    const rulers = document.querySelectorAll('.width-measurement-ruler,.height-measurement-ruler');
    rulers.forEach(ruler => {
        ruler.classList.toggle('hide-ruler');
    });
}

let isGrayscale = false;
let grayscaleImage = null;
function toggleGrayscale() {
    isGrayscale = !isGrayscale;
    if (isGrayscale && !grayscaleImage) {
        grayscaleImage = createGrayscaleImage(image);
    }
    drawHorizontallyTiledImage(isGrayscale && grayscaleImage ? grayscaleImage : image);
}

function createGrayscaleImage(srcImage) {
    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d');
    tempCanvas.width = srcImage.naturalWidth;
    tempCanvas.height = srcImage.naturalHeight;
    tempCtx.drawImage(srcImage, 0, 0);
    const imageData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
    const data = imageData.data;
    for (let i = 0; i < data.length; i += 4) {
        const luminance = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
        data[i] = data[i + 1] = data[i + 2] = luminance;
    }
    tempCtx.putImageData(imageData, 0, 0);
    const img = new Image();
    img.src = tempCanvas.toDataURL();
    return img;
}
